import { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({} as any);

export default styles;
